import { useEffect, useState } from "react";
import CommonPaginationSection from "../components/common/CommonPaginationSection";
import { OrderContent } from "../components/order/OrderContent";
import getLoans from "../controllers/repayment/getLoans";
import { templateLoanData } from "../data/templateLoanData";
import LoanMenu from "./loan/LoanMenu";
import AutoApprovalToggle from "./AutoApprovalToggle";

function LoanTable() {
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    const res = await getLoans({
      limit: pagination.perPage,
      page: pagination.page,
    }).finally(() => {
      setLoading(false);
    });
    if (res?.return) {
      setPagination({ ...pagination, total: res?.data?.totalData || 10 });
      setOgData(res?.data?.loanRequests);
      setOrders(
        res?.data?.loanRequests?.map((request) => templateLoanData(request))
      );
    }
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  return (
    <div className="flex w-full flex-col bg-white p-4 rounded-lg">
      <div className="w-full flex justify-between items-center">
        <span className="font-bold text-black text-lg ">Transactions</span>
        <div>
          <AutoApprovalToggle />
        </div>
      </div>
      {loading ? (
        <div className="w-full flex items-center justify-center p-4">
          <div className="primaryLoader"></div>
        </div>
      ) : (
        <>
          <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-2 p-1 rounded-md">
            {orders.map((order, index) => (
              <Order
                key={index}
                order={order}
                og={ogData?.at(index)}
                callback={(data) => {
                  setOgData(
                    ogData.map((item, itemIndex) =>
                      itemIndex === index ? data : item
                    )
                  );
                  setOrders(
                    orders.map((item, itemIndex) =>
                      itemIndex === index ? templateLoanData(data) : item
                    )
                  );
                }}
              />
            ))}
          </div>
          <div className="w-full mt-2">
            <CommonPaginationSection
              perPage={pagination.perPage}
              total={pagination.total}
              page={pagination.page}
              callback={(pg, perPage) =>
                setPagination({ ...pagination, page: pg, perPage })
              }
            />
          </div>
        </>
      )}
    </div>
  );
}

export default LoanTable;

const Order = ({ order, og, callback }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open) {
        setTimeout(() => {
          setOpen(false);
        }, 400);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="w-full flex  justify-between bg-white p-4 gap-3 rounded-md font-main">
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full rounded-lg ${width || "flex-1"} ${
              !open && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              open && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          //   bookingData?.status || og?.status ? "flex" : "hidden"
          ""
        } flex-col justify-between items-center `}
      >
        {loading ? (
          <div className="primaryLoader"></div>
        ) : (
          <>
            <button
              className="cursor-pointer p-2 relative "
              disabled={loading}
              onClick={() => setOpen(true)}
            >
              {loading ? (
                <div className="primaryLoader"></div>
              ) : (
                <img
                  src="/IconMore.svg"
                  alt=""
                  className="h-5 object-contain relative"
                />
              )}
              {open && (
                <LoanMenu
                  order={og}
                  loading={loading}
                  setLoading={setLoading}
                  callback={callback}
                />
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
